export default __webpack_public_path__ + "static/media/custom.6b64ddba.png";